<div class="container-xxl flex-grow-1 container-p-y">
  <div class="row mb-6 gy-6">
    <div class="col-xl">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0">ASK AI</h5>
        </div>
                    

        <div class="card-body">
          <form [formGroup]="aiForm" (ngSubmit)="onSubmit()">

            <!-- AI Prompt -->
            <div class="mb-3">
              <textarea class="form-control" id="aiMessage" formControlName="question" rows="3"
                placeholder="ASK AI"></textarea>
            </div>
          
            <!-- Submit Button -->
            <div class="d-flex justify-content-end">
              <button type="submit" class="btn btn-primary" rippleEffect>ASK</button>
            </div>
          
          </form>
        </div>
      </div>
    </div>
  </div>
</div>